
























import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator'
import RemuneracaoMedicaApi from '@/Apis/RemuneracaoMedica/Services/RemuneracaoMedicaApi'
import EventBus from '@/plugins/EventBus'
import { onlyNumber } from '@/utils/common'

@Component
export default class ModalEditarChamadoAgrupamento extends Vue {
  onlyNumber = onlyNumber

  @Prop({ required: true, default: false }) visible: boolean
  @Prop({ default: null }) item: any

  edicao: any = { id: '', numeroChamado: '' }
  formValido = true
  salvando = false

  @Watch('visible')
  onVisibleChange(novoValor: boolean) {
    if (!novoValor || !this.item) return
    this.edicao = { id: this.item.id, numeroChamado: this.item.numeroChamado || '' }
  }

  async salvar() {
    const form = this.$refs.formChamado as any
    if (form && !form.validate()) return

    this.salvando = true
    try {
      const response: any = await RemuneracaoMedicaApi.atualizarAgrupamento(this.edicao)
      if (!response.success) {
        EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Erro ao atualizar.', icon: 'warning', color: '#C62828' })
        return
      }

      EventBus.$emit('setSnackbar', { show: true, text: 'Número do chamado atualizado.', icon: 'check', color: '#2E7D32' })
      this.salvo()
      this.close()
    } finally {
      this.salvando = false
    }
  }

  @Emit('salvo')
  salvo() { }

  @Emit('close')
  close() { }
}
